module.exports = __webpack_public_path__ + "dist/media/logo--sl.6282afa9.svg";